export default "__VITE_ASSET__0cefc46a__"